import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

export default function BaseDivideLine({ dash, top, bottom, className }) {
  BaseDivideLine.propTypes = {
    dash: PropTypes.bool,
    top: PropTypes.bool,
    bottom: PropTypes.bool,
    className: PropTypes.string,
  };
  const cls = ["hr-ln"];
  if (className) cls.push(className);
  if (top) cls.push("hr-ln_top");
  if (bottom) cls.push("hr-ln_bottom");
  if (dash) cls.push("hr-ln__dashed");
  return <div className={cls.join(" ")} />;
}
